import { Typography } from '../../../designComponents';
import { FooterSectionStyled } from '../style';

type Menu = {
  label: string;
  //   url: string;
}[];

const resourcesMenu: Menu = [
  {
    label: 'Symbols',
    // url: '/symbols',
  },
  {
    label: 'Templates',
    // url: '/templates',
  },
  {
    label: 'Technicians',
    // url: '/technicians',
  },
  {
    label: 'Printers',
    // url: '/printers',
  },
  {
    label: 'Admin',
    // url: '/printers',
  },
  {
    label: 'Professional',
    // url: '/printers',
  },
];

const Resources = () => {
  return (
    <FooterSectionStyled>
      <Typography fontColor="white" className="title">
        RESOURCES
      </Typography>
      {resourcesMenu?.map((menu, index) => {
        return (
          <div className="menu" key={index}>
            <Typography fontColor="white" className="menu-item">
              {menu?.label}
            </Typography>
          </div>
        );
      })}
    </FooterSectionStyled>
  );
};

export default Resources;
